import { Box } from "@mui/material";
import { FC, useState } from "react";
import {
  getEndOfWeek,
  getStartOfWeek,
  isSameWeek,
} from "../../../../shared/utils/date";
import { CalendarViewProps } from "../types";
import {
  getInitialSelectedMonth,
  getInitialSelectedYear,
  overWriteStartDate,
} from "../utils";
import { MonthPicker } from "./MonthPicker";
import { WeeksGrid } from "./WeeksGrid";

export const WeeksView: FC<CalendarViewProps> = ({
  tempStartDate,
  tempEndDate,
  setTempStartDate,
  setTempEndDate,
  earliestSelectableDate,
}) => {
  const [selectedYear, setSelectedYear] = useState<number>(
    getInitialSelectedYear(tempEndDate),
  );
  const [selectedMonth, setSelectedMonth] = useState<number>(
    getInitialSelectedMonth(tempEndDate),
  );

  const handleMonthChange = (month: number, year: number) => {
    setSelectedMonth(month);
    setSelectedYear(year);
  };

  const handleDayClick = (date: Date) => {
    const userSelectedWeekStart = getStartOfWeek(date);
    const weekStart = overWriteStartDate(
      userSelectedWeekStart,
      earliestSelectableDate,
    );
    const weekEnd = getEndOfWeek(date);

    if (!tempStartDate || tempEndDate) {
      setTempStartDate(weekStart);
      setTempEndDate(null);
    } else {
      const selectedWeekStart = getStartOfWeek(date);
      const currentStartWeek = getStartOfWeek(tempStartDate);

      if (isSameWeek(date, tempStartDate)) {
        setTempEndDate(weekEnd);
      } else if (selectedWeekStart >= currentStartWeek) {
        setTempEndDate(weekEnd);
      } else {
        setTempStartDate(weekStart);
        setTempEndDate(null);
      }
    }
  };

  return (
    <Box>
      <MonthPicker
        earliestSelectableDate={earliestSelectableDate}
        onMonthChange={handleMonthChange}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
      />

      <WeeksGrid
        earliestSelectableDate={earliestSelectableDate}
        endDate={tempEndDate}
        onDayClick={handleDayClick}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
        startDate={tempStartDate}
      />
    </Box>
  );
};
